/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BrandListResponse } from '../../models/brand-list-response';

export interface GetTenantBrands$Params {

/**
 * Id of a resource.
 */
  id: string;
}

export function getTenantBrands(http: HttpClient, rootUrl: string, params: GetTenantBrands$Params, context?: HttpContext): Observable<StrictHttpResponse<BrandListResponse>> {
  const rb = new RequestBuilder(rootUrl, getTenantBrands.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BrandListResponse>;
    })
  );
}

getTenantBrands.PATH = '/api/v1/tenants/{id}/brands';
